import Typography from "@mui/material/Typography";
import { Chip, Grid, Stack, TextField } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  ProductsOrder,
  setSerialDialog,
} from "../../../../../app/slices/productsOrdersSlice";
import ConfirmationDialog from "../../../../../helpers/ConfirmationDialog";
import { HiOutlineQrCode, HiOutlinePlusCircle } from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  PlainCard,
} from "../../../../../components/FormDialog";

const SerialNumberForm = () => {
  const dispatch = useDispatch();
  const _Serial = useSelector((state) => state.productsOrders.serial);
  const _SearchBody = useSelector((state) => state.productsOrders.searchBody);
  // Read the serials off the table row so the list refreshes after add/delete.
  const _Order = useSelector((state) =>
    state.productsOrders.productsOrders.data?.find(
      (order) => order.id === _Serial.order_id
    )
  );
  const serials = _Order?.serial_numbers ?? [];

  const [toDelete, setToDelete] = useState(null);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: { serial_number: "" },
  });

  const onSubmit = (data) => {
    dispatch(
      ProductsOrder.serial(
        {
          order_id: _Serial.order_id,
          product_id: _Serial.product_id,
          order_product_id: _Serial.order_product_id,
          serial_number: data.serial_number,
        },
        _SearchBody
      )
    ).then(() => reset({ serial_number: "" }));
  };

  const handleDialog = () => {
    dispatch(setSerialDialog({}));
  };

  return (
    <FormDialog
      open={_Serial.dialog}
      onClose={handleDialog}
      icon={<HiOutlineQrCode />}
      title={`الارقام التسلسلية للطلب #${_Serial.order_id ?? "-"}`}
      subtitle="أضف او احذف الارقام التسلسلية للطلب"
      onSubmit={handleSubmit(onSubmit)}
      saveText="اضافة"
    >
      <PlainCard>
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", rowGap: 1 }}>
          {serials.length > 0 ? (
            serials.map((serial) => (
              <Chip
                key={serial.id}
                label={serial.serial_number}
                onDelete={() => setToDelete(serial)}
              />
            ))
          ) : (
            <Typography variant="body2">لا توجد ارقام تسلسلية</Typography>
          )}
        </Stack>
      </PlainCard>
      <SectionCard icon={<HiOutlinePlusCircle />} title="إضافة رقم تسلسلي">
        <Grid item xs={12}>
          <Controller
            name="serial_number"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                required
                size="small"
                label="الرقم التسلسلي"
                fullWidth
              />
            )}
          />
        </Grid>
      </SectionCard>
      <ConfirmationDialog
        open={Boolean(toDelete)}
        title="تاكيد"
        message="هل انت متاكد من حذف الرقم التسلسلي"
        name={toDelete?.serial_number}
        confirmText="حذف"
        cancelText="الغاء"
        onConfirm={() => {
          dispatch(ProductsOrder.deleteSerial(toDelete.id, _SearchBody));
          setToDelete(null);
        }}
        onCancel={() => setToDelete(null)}
      />
    </FormDialog>
  );
};

export default SerialNumberForm;
